"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const InvitationError = props => {
  const {
    auth
  } = props;
  let header = "Sign Up";
  let image = null;
  if (auth.signup && auth.signup.header) header = auth.signup.header;
  if (auth.signup && auth.signup.image) image = `/${auth.signup.image}`;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexFlow: 'column',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'container-fluid pb-5 mt-5'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-8 col-lg-6 col-xl-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'd-flex justify-content-center mb-5'
  }, image && /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow p-5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement("p", null, "Something went wrong with your invitation. Please contact the person who invited you."), /*#__PURE__*/_react.default.createElement("div", {
    className: "alert alert-danger"
  }, props.invitation.error.Message)))))), /*#__PURE__*/_react.default.createElement(_components.ImprintLink, null));
};
const InvitedSignUp = props => {
  const {
    auth
  } = props;
  let header = "Sign Up";
  let image = null;
  if (auth.signup && auth.signup.header) header = auth.signup.header;
  if (auth.signup && auth.signup.image) image = `/${auth.signup.image}`;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexFlow: 'column',
      height: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'container-fluid pb-0 justify-content-center position-relative'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-10 col-lg-8 col-xl-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'd-flex justify-content-center mb-5'
  }, image && /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow p-5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement(_.SignUpForm, props)))))), /*#__PURE__*/_react.default.createElement(_components.ImprintLink, null));
};
class SignUpManager extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleOptinChange", (id, body) => {
      const {
        state,
        onChange
      } = this.props;
      const UserOptInEntries = state.UserOptInEntries.map(optin => {
        if (optin.OptInEntryId === id) return {
          ...optin,
          ...body
        };
        return optin;
      });
      onChange({
        UserOptInEntries
      });
    });
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.invitation.fetched !== nextProps.invitation.fetched && nextProps.invitation.data) {
      nextProps.onChange({
        Invitation: nextProps.invitation.data
      });
      Object.entries(nextProps.invitation.data).map(([key, value]) => {
        if (key in nextProps.state) nextProps.onChange({
          [key]: value
        });
      });
    }
    if (this.props.optins && this.props.optins.fetched !== nextProps.optins.fetched && nextProps.optins.fetched) nextProps.onChange({
      UserOptInEntries: nextProps.optins.data.map(optin => {
        return {
          OptInEntryId: optin.Id,
          UserAccepted: false
        };
      })
    });
  }
  render() {
    const {
      auth,
      invitation
    } = this.props;
    if (auth.invitedSignUp && invitation.data) return /*#__PURE__*/_react.default.createElement(InvitedSignUp, this.props);
    if (auth.invitedSignUp && invitation.error) return /*#__PURE__*/_react.default.createElement(InvitationError, this.props);
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_components.Spinner, null));
  }
}
var _default = exports.default = SignUpManager;
module.exports = exports.default;